'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dGrocery$002dItem$002dSort from "./mealorama.-Grocery-Item-Sort.js";
var $p;
/** @constructor */
function $c_Lmealorama_GroceryItemSort$() {
}
export { $c_Lmealorama_GroceryItemSort$ as $c_Lmealorama_GroceryItemSort$ };
$p = $c_Lmealorama_GroceryItemSort$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_GroceryItemSort$;
/** @constructor */
function $h_Lmealorama_GroceryItemSort$() {
}
export { $h_Lmealorama_GroceryItemSort$ as $h_Lmealorama_GroceryItemSort$ };
$h_Lmealorama_GroceryItemSort$.prototype = $p;
$p.m = (function() {
  return "GroceryItemSort";
});
$p.aSg = (function(x$0) {
  return new $j_mealorama$002e$002dGrocery$002dItem$002dSort.$c_Lmealorama_GroceryItemSort(x$0.g(0), x$0.g(1));
});
var $d_Lmealorama_GroceryItemSort$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_GroceryItemSort$, "mealorama.GroceryItemSort$", ({
  FN: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_GroceryItemSort$ as $d_Lmealorama_GroceryItemSort$ };
var $n_Lmealorama_GroceryItemSort$;
function $m_Lmealorama_GroceryItemSort$() {
  if ((!$n_Lmealorama_GroceryItemSort$)) {
    $n_Lmealorama_GroceryItemSort$ = new $c_Lmealorama_GroceryItemSort$();
  }
  return $n_Lmealorama_GroceryItemSort$;
}
export { $m_Lmealorama_GroceryItemSort$ as $m_Lmealorama_GroceryItemSort$ };
//# sourceMappingURL=mealorama.-Grocery-Item-Sort$.js.map
